export enum NavEvents {
  TOGGLE_COLLAPSE = 'nav:toggle-collapse',
}
